module.exports = __webpack_public_path__ + "img/xxnl-app.33fc0280.png";